import { render } from "./EditYearMonths.vue?vue&type=template&id=1ec513d0"
import script from "./EditYearMonths.vue?vue&type=script&lang=js"
export * from "./EditYearMonths.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__